import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  Services,
  Navigation,
  Home,
  Shop,
  Dashboard,
  Reservation,
  About,
  Login,
  Register,
  PageNotFound,
  LoadingWrapper,ProductDetails,
  
} from "../src/Pages/index.js";

function App() {
  return (
    <BrowserRouter>
      <LoadingWrapper>
        <Routes>
          <Route path="" element={<Navigation is />}>
            <Route index path="/" element={<Home />} />
            <Route path="services" element={<Services />} />
            <Route path="shop" element={<Shop />} />
            <Route path="shop/product/:id" element={<ProductDetails />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="reservation" element={<Reservation />} />
            <Route path="about" element={<About />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
      </LoadingWrapper>
    </BrowserRouter>
  );
}

export default App;
